import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ITenderRequirement } from 'types/tender/tenderRequirements'
import { IdParams } from 'types/api'

export const tenderRequirementsApi = createApi({
  reducerPath: 'tenderRequirements',
  baseQuery,
  endpoints: (builder) => ({
    tenderRequirements: builder.query<ITenderRequirement[], void>({
      query: () => ({
        url: '/tender-requirements',
      }),
    }),

    tenderRequirement: builder.query<ITenderRequirement, IdParams>({
      query: ({ id }) => `/tender-requirements/${id}`,
    }),

    createTenderRequirement: builder.mutation<
      ITenderRequirement,
      Partial<ITenderRequirement>
    >({
      query: (body) => ({
        url: '/tender-requirements',
        body,
        method: 'post',
      }),
    }),

    updateTenderRequirement: builder.mutation<
      ITenderRequirement,
      Partial<ITenderRequirement>
    >({
      query: (body) => ({
        url: `/tender-requirements/${body.id}`,
        body,
        method: 'put',
      }),
    }),

    deleteTenderRequirement: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/tender-requirements/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useTenderRequirementQuery,
  useTenderRequirementsQuery,
  useCreateTenderRequirementMutation,
  useUpdateTenderRequirementMutation,
  useDeleteTenderRequirementMutation,
} = tenderRequirementsApi
